import { Home, LiveHelp, Info, ContactPhone } from '@mui/icons-material'
import IntlMessages from '../util/IntlMessages'
import * as router from './router'

export const menuList = [
    { router: router.HOME, label: <IntlMessages id="home" />, icon: <Home /> },
    { router: router.ABOUTS, label: <IntlMessages id="abouts" />, icon: <Info /> },
    { router: router.CONTACT_US, label: <IntlMessages id="contact-us" />, icon: <ContactPhone /> },
    { router: router.FAQ, label: <IntlMessages id="faq" />, icon: <LiveHelp /> },
]
